<navigation-list-desktop
  *ngIf="mode === 'desktop'"
  [items]="items"
  [isOpen]="isOpen"
  [descriptionVisible]="descriptionVisible"
></navigation-list-desktop>

<navigation-list-mobile *ngIf="mode === 'mobile'" [items]="items"></navigation-list-mobile>

<navigation-list-tabs *ngIf="mode === 'tab'" [items]="items ?? []"></navigation-list-tabs>
